import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authAxios } from "../../api/axiosClient";
import { userInfoURL } from "../../constants";

const initialState = {
  status: "idle",
  userInfo: undefined,
  timeSystem: null,
  error: null,
};

export const getUserInfo = createAsyncThunk(
  "user/getUserInfo",
  async (token, { rejectWithValue }) => {
    try {
      //tắt
      const response = await authAxios().get(userInfoURL);
      return response.data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserInfo.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getUserInfo.fulfilled, (state, action) => {
        state.status = "idle";
        state.userInfo = action.payload.message;
      })
      .addCase(getUserInfo.rejected, (state, action) => {
        state.status = "idle";
      });
    //   .addCase(getSystemInfo.pending, (state) => {
    //   state.status = 'loading';

    // })
    // .addCase(getSystemInfo.fulfilled, (state, action) => {
    //   state.status = 'idle';
    //   state.timeSystem = action.payload
    // })
    // .addCase(getSystemInfo.rejected, (state, action) => {
    //   state.status = 'idle';
    // })
  },
});

export default userSlice.reducer;
